"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentUploadActivity = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const frontend_infra_snack_1 = require("@forto-dev/frontend-infra-snack");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const ConfigContext_1 = require("../../../lib/ConfigContext");
const url_1 = require("../../../util/url");
const useStyles = (0, silhouette_core_1.makeStyles)({
    documentNameWrapper: {
        maxWidth: '80%',
    },
    documentName: {
        overflow: 'hidden',
        whiteSpace: 'pre',
        textOverflow: 'ellipsis',
        maxWidth: '300px',
    },
});
const downloadDocument = async (documentId, url, token, filename) => {
    const response = await fetch(url, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    if (!response.ok)
        throw new Error(response.statusText);
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.download = filename;
    link.setAttribute('data-e2e-id', 'activity-feed-document-download');
    link.setAttribute('data-document-id', documentId);
    link.href = objectUrl;
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(objectUrl);
    document.body.removeChild(link);
};
const DocumentUploadActivity = ({ activity, shipmentId, onDocumentDownload = downloadDocument, }) => {
    const snackService = (0, frontend_infra_snack_1.useSnackService)();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const classes = useStyles();
    const config = (0, ConfigContext_1.useConfigContext)();
    const { state: { token }, } = (0, frontend_infra_auth_1.useAuth)();
    const getURL = (documentId) => {
        const path = `/documents/shipment/${shipmentId}${documentId ? `/${documentId}` : ''}/download`;
        return (0, url_1.getAPIUrl)(path, config.DOCUMENTS_CORE_V2_ENDPOINT, false);
    };
    let { name, document_id: documentID } = activity;
    if (!name && activity.context?.name) {
        name = activity.context.name;
    }
    if (!documentID && activity.context?.document_id) {
        documentID = activity.context.document_id;
    }
    const handleDownload = async () => {
        const url = getURL(documentID);
        if (!documentID) {
            snackService.showError(translate('activity_feed-document_download_error'));
            return;
        }
        try {
            await onDocumentDownload(documentID, url, token, name);
        }
        catch (e) {
            snackService.showError(translate('activity_feed-document_download_error'));
        }
    };
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { container: true, alignItems: "center", spacing: 1, children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { className: classes.documentNameWrapper, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "body2", className: classes.documentName, title: name, children: name || 'Unknown filename' }) }), documentID && ((0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { children: (0, jsx_runtime_1.jsx)(silhouette_core_1.IconButton, { size: "small", onClick: handleDownload, "data-document-id": documentID, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.GetAppIcon, {}) }) }))] }));
};
exports.DocumentUploadActivity = DocumentUploadActivity;
//# sourceMappingURL=DocumentUploadActivity.js.map